module.exports = __webpack_public_path__ + "img/upskillvthcourse.39ce2665.svg";